import { render } from "./EvaluationPage.vue?vue&type=template&id=09c71fed&ts=true"
import script from "./EvaluationPage.vue?vue&type=script&lang=ts"
export * from "./EvaluationPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DanhGia_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__